import { RandomId, StringHelper } from "@swivl-mono/helpers";
import { NodeData_Note, NodeInterface, NodeType } from "@swivl-mono/types";
import { Input, Switch } from "@swivl-mono/ui";

import { TagInput, TagInputType } from "../../../../../Components/TagInput/TagInput";
import VarsModel from "../../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const NoteNode = {
  Type: NodeType.Note,
  Empty: function () {
    return {
      id: RandomId(6),
      type: NodeType.Note,
      updateExistingNote: false,
      slug: RandomId(6),
      saveToFMS: false,
      title: "New Note",
      content: "",
      goto: ""
    } as NodeData_Note;
  },

  PlumbData: function (node: NodeInterface) {
    let note = StringHelper.trimStringToLengthWithElipsis(VarsModel.replaceVariableNameInString(node.note), 80);

    const tabs = [{ id: "goto", source: "goto", target: node.goto }];

    const title = node.action === "CLEAR" ? "" : VarsModel.replaceVariableNameInString(node.values);

    return TabNodeLayoutData({
      node: node,
      body: note,
      title: "Note",

      baseWidth: 300,
      tabs: tabs
    });
  },

  InspectorPanel: class IncrementInspectorPanel extends NodePanel {
    render() {
      const node = this.props.node as NodeData_Note;

      return (
        <div className="panel NoteNodePanel">
          <InspectorNodeHeader title="Note" />

          <TagInput label="Title" value={node.title} onChange={this.onChange} name="title" type={TagInputType.SingleLine} />
          <TagInput label="Body" value={node.content} onChange={this.onChange} name="content" />

          <label htmlFor="saveToFMS">Save to FMS</label>
          <Switch
            on={node.saveToFMS || false}
            name="saveToFMS"
            onSet={(on: boolean, name?: string) => {
              return this.onChangeSwitch(name!, on);
            }}
          />

          <label>Update Existing</label>
          <Switch
            on={node.updateExistingNote || false}
            name="updateExistingNote"
            onSet={(on: boolean, name?: string) => {
              return this.onChangeSwitch(name!, on);
            }}
          />
          {node.updateExistingNote && (
            <>
              <Input
                label="Note Slug"
                type="text"
                value={node.slug || ""}
                onChange={this.onChange}
                name="slug"
                placeholder="Unique slug..."
                helperText="If a note with this slug already exists for this user, it will be updated. Otherwise, a new note will be created."
                containerClassName="mt-2"
              />
            </>
          )}

          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default NoteNode;
